import { render, staticRenderFns } from "./FieldRenderer.vue?vue&type=template&id=b3bf96a4"
import script from "./FieldRenderer.vue?vue&type=script&lang=js"
export * from "./FieldRenderer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports